import {
  ARROW_STYLES,
  CUSTOM_STYLES,
  SIGN,
  TESTIMONIALS_CUSTOM_STYLES,
  TITLE_STYLES,
} from "@/constants/candidates";
import CompanySlide from "@/components/Shared/CompanySlider";
import FaqsSection from "@/components/Shared/FaqsSection";
import SubmitForm from "@/components/Shared/SubmitForm";
import FindRole from "@/components/Shared/FindRole";
import Testimonials from "@/components/Shared/Testimonials";
import ColoredHeader from "@/components/Shared/ColoredHeader";
import SEO from "@/components/SEO";
import Collection from "@sourceflow-uk/sourceflow-sdk/collection";
import localizePath from "@/functions/localizePath";
import headerCorner from "@/assets/candidates/header-corner.png";
import footerCorner from "@/assets/candidates/footer-corner.png";
import banner from "@/assets/candidates/header-banner.png";
import useJobs from "@/hooks/useJobs";

export default function CandidatesPage({ locale = "en", faqs }) {
  const jobs = useJobs();

  return (
    <>
      <SEO
        path={localizePath("/candidates", locale)}
        title="Candidates | Lawrence Harvey"
        description="Find your candidates here"
      />
      <main className="bg-gradientDarkGreen pt-[120px] pb-16 h-full md:pb-[145px] relative appear">
        <ColoredHeader
          textBtn="Search jobs"
          link={localizePath("/jobs", locale)}
          backgroundImage={banner ?? ""}
          text="Us, you, and your next role in tech. Here’s what that looks like."
          path="candidates"
        />
        <div className="absolute top-0 right-0 hidden lg:block">
          <img src={headerCorner ?? ""} alt="top corner banner " />
        </div>
        <CompanySlide
          isFooterExists={false}
          path="candidates.company_slide"
          learnMore="Learn more about us"
          title="Tech jobs that get you moving"
          description="We work with and value the big players in the tech markets, as much as the new up-and-comers. Whichever is the best fit for you, we’ll get it right."
        />
        <FindRole
          titleColor="white"
          path="dynamic1.candidates.find_role"
          jobs={jobs}
        />
        <Testimonials customStyles={TESTIMONIALS_CUSTOM_STYLES} />
        <img
          src={footerCorner ?? ""}
          alt="background-part-bottom"
          className="absolute left-0 bottom-[60px] right-corner-img"
        />
      </main>
      <div className="bg-white candidates-page appear">
        <FaqsSection
          customClass="candidate-page"
          arrowStyles={ARROW_STYLES}
          blogsProps={{
            title:
              "Interview advice, insights and trends to help with your next role.",
            styles: {
              txt: "text-purple",
              active: "purple",
              inactive: "white",
              arrow: "[&>path]:fill-white [&>path]:stroke-white",
            },
          }}
          readToApplyBg="bg-green"
          link={localizePath("/jobs", locale)}
          bgColor="bg-white"
          titleStyles={TITLE_STYLES}
          sign={SIGN}
          customStyles={CUSTOM_STYLES}
          faqs={faqs.map(({ name, description }) => ({
            question: name,
            answer: description,
          }))}
          pathPrefix="candidates_page"
        />
      </div>
      <div className="bg-purple pt-20 appear">
        <SubmitForm />
      </div>
    </>
  );
}

export async function getStaticProps() {
  const faqs = (await Collection("candidates_faq")).getItems();

  return { props: { faqs } };
}
